export default "__VITE_ASSET__CO751u0F__"